export const DARK = "dark";
export const LIGHT = "light";

export type ThemeModel = "dark" | "light" | null | undefined;
